<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <StudentFilters 
            :search="search"
            :download-url="download"
            @search="handleSearch"
            @disable-users="openDisableUsersModal"
            @bulk-upload="scrollToBulkUpload"
            @add-user="scrollToAddUser"
        />

        <StudentTable 
            :students="users"
            :loading="loading"
            :current-page="page"
            :page-count="pageCount"
            :items-per-page="itemsPerPage"
            @edit-student="editStudent"
            @page-change="handlePageChange"
        />

        <modalVideo
            url="https://www.youtube.com/embed/TS78y_6v7bg?si=_EJfQjk5SO4w7YLi"
            v-if="openVideoModal"
            @onClose="openVideoModal = false"
        ></modalVideo>
        
        <modaldisableusers
            v-if="disableModalVisible"
            :urlstudents="url"
            @reloadtable="reloadTable"
            @close="closeDisableUsersModal"
        ></modaldisableusers>
    </div>
</template>

<script>
import modalVideo from '../tutorials/ModalTutorial.vue';
import modaldisableusers from './ModalDisableUsers.vue';
import StudentFilters from './StudentFilters.vue';
import StudentTable from './StudentTable.vue';

export default {
    name: 'DataTable',
    
    components: {
        modalVideo,
        modaldisableusers,
        StudentFilters,
        StudentTable
    },
    
    props: [
        "get",
        "headertab",
        "rol",
        "routexuser",
        "userxroutes",
        "routes",
        "trashes",
        "download",
        "reloadTable"
    ],
    
    data() {
        return {
            search: "",
            url: this.get,
            users: [],
            totalItems: 0,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            loading: false,
            openVideoModal: false,
            disableModalVisible: false,
            searchTimeout: null
        };
    },
    
    mounted() {
        this.getData();
    },
    
    watch: {
        reloadTable(newVal) {
            if (newVal === true) {
                this.getData();
            }
        },
        search(newVal) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.page = 1;
                this.getData();
            }, 400);
        }
    },
    
    methods: {
        getData() {
            this.loading = true;
            const params = new URLSearchParams(location.search);
            let course = params.get('course');
            let param = "?withUsers=true";
            
            if (this.trashes) param = "?onlyTrashes=true";
            if (course) param += `&course=${course}`;
            if (this.page) param += `&page=${this.page}`;
            if (this.itemsPerPage) param += `&per_page=${this.itemsPerPage}`;
            if (this.search) param += `&search=${this.search}`;

            axios.get(this.url + param)
                .then((res) => {
                    this.users = res.data.data;
                    this.totalItems = res.data.total;
                    this.page = res.data.current_page;
                    this.pageCount = res.data.last_page;
                })
                .catch((error) => {
                    console.error('Error loading data:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        
        handleSearch(searchText) {
            this.search = searchText;
        },
        
        handlePageChange(page) {
            this.page = page;
            this.getData();
        },
        
        editStudent(data) {
            this.$emit("setDataStudent", data);
        },
        
        scrollToBulkUpload() {
            document.getElementById('carga_masiva_estudiante')?.scrollIntoView({ behavior: 'smooth' });
        },
        
        scrollToAddUser() {
            document.getElementById('agregar_estudiante')?.scrollIntoView({ behavior: 'smooth' });
        },
        
        openDisableUsersModal() {
            this.disableModalVisible = true;
        },
        
        closeDisableUsersModal() {
            this.disableModalVisible = false;
        }
    }
};
</script>

<style>
.searcher.search-nomargin {
    border-color: #212529 !important;
    margin-bottom: 0 !important;
}
</style>